import Svg, { ClipPath, Defs, Ellipse, G, Path, Rect } from 'react-native-svg';
import { TIllustrationProps } from './types';

export function IllustrationTwoCard({
  width = 61,
  height = 61,
  className,
}: TIllustrationProps) {
  return (
    <Svg
      width={width}
      height={height}
      fill="none"
      className={className}
      viewBox="0 0 61 61"
    >
      <G clipPath="url(#illustration-two-card-a)">
        <G filter="url(#illustration-two-card-b)">
          <Rect
            width={38.217}
            height={24.555}
            x={21.468}
            y={7.76}
            fill="#FE7165"
            rx={6.326}
          />
        </G>
        <Rect
          width={5.319}
          height={0.967}
          x={25.014}
          y={22.069}
          fill="#fff"
          opacity={0.5}
          rx={0.483}
        />
        <Path
          fill="#FFE7D7"
          d="M21.468 12.593h38.217v5.414H21.468z"
          opacity={0.8}
        />
        <Rect
          width={5.319}
          height={0.967}
          x={30.923}
          y={22.069}
          fill="#fff"
          opacity={0.5}
          rx={0.483}
        />
        <Rect
          width={5.319}
          height={0.967}
          x={36.637}
          y={22.069}
          fill="#fff"
          opacity={0.5}
          rx={0.483}
        />
        <Rect
          width={5.319}
          height={0.967}
          x={42.545}
          y={22.069}
          fill="#fff"
          opacity={0.5}
          rx={0.483}
        />
        <G filter="url(#illustration-two-card-c)">
          <Rect
            width={38.17}
            height={24.587}
            fill="#7CCCC5"
            rx={6.326}
            transform="matrix(.96711 .25434 -.26337 .9647 23.63 19.033)"
          />
        </G>
        <Rect
          width={5.312}
          height={0.968}
          fill="#fff"
          opacity={0.5}
          rx={0.484}
          transform="matrix(.96711 .25434 -.26337 .9647 23.282 33.755)"
        />
        <Path
          fill="#DCF2EB"
          d="m22.355 23.701 36.914 9.708-1.427 5.23-36.915-9.708z"
          opacity={0.8}
        />
        <Rect
          width={5.312}
          height={0.968}
          fill="#fff"
          opacity={0.5}
          rx={0.484}
          transform="matrix(.96711 .25434 -.26337 .9647 28.99 35.255)"
        />
        <Rect
          width={5.312}
          height={0.968}
          fill="#fff"
          opacity={0.5}
          rx={0.484}
          transform="matrix(.96711 .25434 -.26337 .9647 34.507 36.708)"
        />
        <Rect
          width={5.312}
          height={0.968}
          fill="#fff"
          opacity={0.5}
          rx={0.484}
          transform="matrix(.96711 .25434 -.26337 .9647 40.219 38.209)"
        />
        <Path
          fill="#FFE5D8"
          fillRule="evenodd"
          d="M.545 22.69c0 6.874 5.678 12.446 12.682 12.446h2.805a.75.75 0 0 0 .087-.003c.1.002.201.003.303.003h3.255l.192-.001h1.366c6.144 0 11.124-4.98 11.124-11.124V22.69c0-6.874-5.678-12.447-12.682-12.447-.551 0-1.095.035-1.628.102a13.029 13.029 0 0 0-3.225-.004 13.047 13.047 0 0 0-1.597-.098C6.223 10.242.545 15.815.545 22.69Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FDBD9A"
          fillRule="evenodd"
          d="M13.554 33.757c-6.255 0-11.326-4.977-11.326-11.116 0-6.14 5.07-11.116 11.326-11.116 6.255 0 11.325 4.977 11.325 11.116v11.116H13.554Z"
          clipRule="evenodd"
        />
        <Rect
          width={1.555}
          height={7.472}
          x={12.776}
          y={17.542}
          fill="#F2F2F2"
          rx={0.778}
        />
        <Ellipse cx={13.554} cy={26.817} fill="#F2F2F2" rx={0.938} ry={0.92} />
        <Path
          fill="#FF8D78"
          fillRule="evenodd"
          d="M16.405 33.757C10.15 33.757 5.08 28.78 5.08 22.64c0-6.14 5.07-11.116 11.325-11.116 6.255 0 11.326 4.977 11.326 11.116 0 .925-.073 1.826-.22 2.688.143.41.22.85.22 1.308v3.147a3.972 3.972 0 0 1-3.972 3.973h-3.306c-.25 0-.495-.024-.732-.068a10.7 10.7 0 0 1-.538.068c-.288.029-1.487.014-2.233.005l-.544-.005Z"
          clipRule="evenodd"
        />
        <Rect
          width={1.555}
          height={7.472}
          x={15.629}
          y={17.544}
          fill="#F2F2F2"
          rx={0.778}
        />
        <Ellipse cx={16.407} cy={26.818} fill="#F2F2F2" rx={0.938} ry={0.92} />
        <Path
          fill="#FE7165"
          fillRule="evenodd"
          d="M19.31 33.757c-6.254 0-11.325-4.977-11.325-11.116 0-6.14 5.07-11.116 11.326-11.116 6.255 0 11.325 4.977 11.325 11.116v2.036a9.08 9.08 0 0 1-9.08 9.08h-2.245Z"
          clipRule="evenodd"
        />
        <Rect
          width={2.241}
          height={10.77}
          x={18.187}
          y={15.293}
          fill="#F2F2F2"
          rx={1.121}
        />
        <Ellipse cx={19.308} cy={28.662} fill="#F2F2F2" rx={1.351} ry={1.326} />
      </G>
      <Defs>
        <ClipPath id="illustration-two-card-a">
          <Path fill="#fff" d="M0 .124h60.545v60H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}
